import { render } from "./KarussellMotorrad1.vue?vue&type=template&id=1fe248db"
import script from "./KarussellMotorrad1.vue?vue&type=script&lang=js"
export * from "./KarussellMotorrad1.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__